import React, { useEffect, useState } from "react";
import Ellipse1 from "../../../Assets/dashboard/Dashboard/Ellipse1.png";
import Ellipse2 from "../../../Assets/dashboard/Dashboard/Ellipse2.png";
import Ellipse3 from "../../../Assets/dashboard/Dashboard/Ellipse3.png";
import { useCountProvider } from "../../../Providers/Consultant/Count";
import Timesheet from "./Dashboard/DashboardCards/Timesheet";
import ListOfJobs from "./Dashboard/ListOfJobs";
import OngoingJobInformation from "./Dashboard/OngoingJobInformation";
import { useConnectionProvider } from "../../../Providers/Consultant/Connection";
import { useNavigate } from "react-router-dom";

export default function DashboardConsultant({ setActive, activeCard }) {
  const { counts } = useCountProvider();
  const { fetchvendorRequests } = useConnectionProvider();
  const [card, setCard] = useState("");
  const [jobId, setJobId] = useState(null);
  const [isHovered, setIsHovered] = useState(-1);

  useEffect(() => {
    fetchvendorRequests()
  }, [])

  const navigate = useNavigate()

  useEffect(() => {
    setCard(activeCard || "")
  }, [])

  return (
    <div>
      {jobId === null ? (
        card.length === 0 ? (
          <>
            <div className="flex lg:flex-row lg:space-y-0 space-y-8 items-center flex-col lg:items-start lg:items-between lg:space-x-8 lg:justify-between">
              <div
                onClick={() => {
                  navigate("/dashboard/timesheetscard")
                }}
                className="flex h-[28vh] hover:shadow-xl hover:cursor-pointer flex-row lg:w-[40%] w-[100%] rounded-lg overflow-hidden justify-between"
                style={{
                  backgroundColor: "#F64E60",
                  boxShadow: isHovered === 1
                    ? '0px 8px 8px rgba(0, 0, 0, 0.35)' // increased shadow
                    : '0px 4px 4px rgba(0, 0, 0, 0.25)', // default shadow
                  transition: 'box-shadow 0.2s ease', // smooth transition
                }}
                onMouseEnter={() => setIsHovered(1)}
                onMouseLeave={() => setIsHovered(-1)}
              >
                <div className="flex ml-4 py-8 flex-col justify-center text-white">
                  <span>
                    <svg
                      width="34"
                      height="34"
                      viewBox="0 0 34 34"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.2381 27.5238V9.71429V27.5238ZM3.2381 30.7619C2.34762 30.7619 1.58559 30.4451 0.952 29.8115C0.317333 29.1769 0 28.4143 0 27.5238V9.71429C0 8.82381 0.317333 8.06178 0.952 7.42819C1.58559 6.79352 2.34762 6.47619 3.2381 6.47619H9.71429V3.2381C9.71429 2.34762 10.0316 1.58505 10.6663 0.950381C11.2999 0.316793 12.0619 0 12.9524 0H19.4286C20.319 0 21.0816 0.316793 21.7163 0.950381C22.3499 1.58505 22.6667 2.34762 22.6667 3.2381V6.47619H29.1429C30.0333 6.47619 30.7959 6.79352 31.4306 7.42819C32.0642 8.06178 32.381 8.82381 32.381 9.71429V16.6357C31.8952 16.2849 31.3825 15.9811 30.8429 15.7242C30.3032 15.4684 29.7365 15.246 29.1429 15.0571V9.71429H3.2381V27.5238H14.6929C14.7738 28.0905 14.8952 28.6437 15.0571 29.1833C15.219 29.723 15.4214 30.2492 15.6643 30.7619H3.2381ZM12.9524 6.47619H19.4286V3.2381H12.9524V6.47619ZM25.9048 34C23.6651 34 21.7562 33.211 20.1782 31.633C18.5991 30.0538 17.8095 28.1444 17.8095 25.9048C17.8095 23.6651 18.5991 21.7557 20.1782 20.1766C21.7562 18.5985 23.6651 17.8095 25.9048 17.8095C28.1444 17.8095 30.0538 18.5985 31.633 20.1766C33.211 21.7557 34 23.6651 34 25.9048C34 28.1444 33.211 30.0538 31.633 31.633C30.0538 33.211 28.1444 34 25.9048 34ZM28.5762 29.7095L29.7095 28.5762L26.7143 25.581V21.0476H25.0952V26.2286L28.5762 29.7095Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  <span className="mt-4">{counts.timesheets}</span>
                  <span>Timesheets</span>
                </div>
                <img alt="ring" className="h-44" src={Ellipse1} />
              </div>
              <div
                className="flex h-[28vh] hover:shadow-xl hover:cursor-pointer flex-row lg:w-[40%] w-[100%] rounded-lg overflow-hidden justify-between"
                style={{
                  backgroundColor: "#6993FF",
                  boxShadow: isHovered === 2
                    ? '0px 8px 8px rgba(0, 0, 0, 0.35)' // increased shadow
                    : '0px 4px 4px rgba(0, 0, 0, 0.25)', // default shadow
                  transition: 'box-shadow 0.2s ease', // smooth transition
                }}
                onMouseEnter={() => setIsHovered(2)}
                onMouseLeave={() => setIsHovered(-1)}
                onClick={() => {
                  navigate("/dashboard/my-jobs")
                }}
              >
                <div className="flex ml-4 py-8 flex-col justify-center text-white">
                  <span>
                    <svg
                      width="34"
                      height="34"
                      viewBox="0 0 34 34"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M3.2381 30.7619C2.34762 30.7619 1.58559 30.4451 0.952 29.8115C0.317333 29.1769 0 28.4143 0 27.5238V9.71429C0 8.82381 0.317333 8.06178 0.952 7.42819C1.58559 6.79352 2.34762 6.47619 3.2381 6.47619H9.71429V3.2381C9.71429 2.34762 10.0316 1.58505 10.6663 0.950381C11.2999 0.316794 12.0619 0 12.9524 0H19.4286C20.319 0 21.0816 0.316794 21.7163 0.950381C22.3499 1.58505 22.6667 2.34762 22.6667 3.2381V6.47619H29.1429C30.0333 6.47619 30.7959 6.79352 31.4306 7.42819C32.0642 8.06178 32.381 8.82381 32.381 9.71429V27.5238C32.3306 28.5 32.3306 29.5 31.8306 30C31.2191 30.6115 28.3306 29 29.1429 27.5238V9.71429H3.2381V27.5238H29.1429C31.8306 26 31.0687 30.7619 31.8306 30C31.1533 30.6772 30.1971 30.7619 29.1429 30.7619H3.2381ZM12.9524 6.47619H19.4286V3.2381H12.9524V6.47619Z" fill="white" />
                    </svg>
                  </span>
                  <span className="mt-4">{counts.jobs}</span>
                  <span>My Jobs</span>
                </div>
                <img alt="ring" className="h-44" src={Ellipse2} />
              </div>
              <div
                className="flex h-[28vh] hover:shadow-xl hover:cursor-pointer flex-row lg:w-[40%] w-[100%] rounded-lg overflow-hidden justify-between"
                style={{
                  backgroundColor: "#1BC5BD",
                  boxShadow: isHovered === 3
                    ? '0px 8px 8px rgba(0, 0, 0, 0.35)' // increased shadow
                    : '0px 4px 4px rgba(0, 0, 0, 0.25)', // default shadow
                  transition: 'box-shadow 0.2s ease', // smooth transition
                }}
                onMouseEnter={() => setIsHovered(3)}
                onMouseLeave={() => setIsHovered(-1)}
              >
                <div className="flex ml-4 py-8 flex-col justify-center text-white">
                  <span className="-ml-5">
                    <svg
                      width="72"
                      height="34"
                      viewBox="0 0 34 34"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M25.5059 0C21.591 0 18.3649 3.15886 18.3649 7.03982C18.3649 10.9208 21.591 14.0884 25.5059 14.0884C29.4208 14.0884 32.6469 10.9208 32.6469 7.03982C32.6469 3.15886 29.4208 0 25.5059 0ZM25.5059 2.9916C27.8219 2.9916 29.6447 4.79614 29.6447 7.03982C29.6447 9.28349 27.8219 11.0997 25.5059 11.0997C23.1899 11.0997 21.3643 9.28339 21.3643 7.03982C21.3643 4.79625 23.1899 2.9916 25.5059 2.9916ZM8.94531 4.74576C5.59034 4.74576 2.83246 7.48311 2.83246 10.8225C2.83246 14.1618 5.59034 16.8904 8.94531 16.8904C12.3003 16.8904 15.067 14.1619 15.067 10.8225C15.067 7.483 12.3003 4.74576 8.94531 4.74576ZM42.0547 4.74576C38.6998 4.74576 35.9448 7.48311 35.9448 10.8225C35.9448 14.1618 38.6998 16.8904 42.0547 16.8904C45.4097 16.8904 48.1676 14.1619 48.1676 10.8225C48.1676 7.483 45.4097 4.74576 42.0547 4.74576ZM8.94531 7.73448C10.6851 7.73448 12.0676 9.10417 12.0676 10.8225C12.0676 12.5408 10.6851 13.9017 8.94531 13.9017C7.20548 13.9017 5.83468 12.5408 5.83468 10.8225C5.83468 9.10417 7.20548 7.73448 8.94531 7.73448ZM42.0547 7.73448C43.7946 7.73448 45.1654 9.10417 45.1654 10.8225C45.1654 12.5408 43.7946 13.9017 42.0547 13.9017C40.3149 13.9017 38.9441 12.5408 38.9441 10.8225C38.9441 9.10417 40.3149 7.73448 42.0547 7.73448ZM25.5059 14.8706C19.6675 14.8706 14.8998 19.5354 14.8998 25.3077V32.4993C14.8965 33.3245 15.5656 33.9961 16.3936 33.9995H34.6156C35.014 33.9987 35.3956 33.8403 35.6764 33.5588C35.9571 33.2774 36.1141 32.8963 36.1124 32.4994V25.3077C36.1124 19.5355 31.3447 14.8706 25.5063 14.8706L25.5059 14.8706ZM8.94531 17.6841C4.01912 17.6841 1.31482e-05 21.6623 1.31482e-05 26.5628V32.4993C-0.00166048 32.8975 0.156503 33.2803 0.439373 33.5617C0.721814 33.8436 1.10594 34.0012 1.50554 33.9995H11.1596C11.563 34.0083 11.9534 33.8548 12.2418 33.5738C12.5305 33.2924 12.6928 32.9075 12.6928 32.5051C12.6928 32.1032 12.5305 31.7179 12.2418 31.4364C11.9535 31.1554 11.5631 31.002 11.1596 31.0107H2.99931V26.5627C2.99931 23.2729 5.62202 20.6728 8.94528 20.6728C9.94785 20.6728 10.8805 20.9113 11.7015 21.3353C12.0559 21.5242 12.4714 21.5638 12.8554 21.4449C13.2391 21.3261 13.5593 21.0593 13.7442 20.7036C13.9292 20.348 13.9635 19.9335 13.8392 19.5524C13.7153 19.1717 13.4434 18.8561 13.0839 18.6764C11.8466 18.0376 10.4314 17.6841 8.94515 17.6841L8.94531 17.6841ZM42.0547 17.6841C40.5392 17.6841 39.1031 18.0581 37.8486 18.7203C37.4833 18.8983 37.2063 19.216 37.0808 19.6013C36.9552 19.9865 36.9921 20.406 37.1825 20.7638C37.3733 21.1215 37.7013 21.3867 38.0921 21.4989C38.4825 21.611 38.9022 21.5606 39.2546 21.3588C40.0873 20.9193 41.0326 20.6729 42.0548 20.6729C45.3779 20.6729 48.0124 23.273 48.0124 26.5628V31.0109H39.8521C39.4487 31.0021 39.0583 31.1556 38.77 31.4366C38.4813 31.718 38.3189 32.1033 38.3189 32.5053C38.3189 32.9076 38.4813 33.2925 38.77 33.5739C39.0583 33.855 39.4487 34.0084 39.8521 33.9996H49.5062C50.3343 33.9963 51.0034 33.3246 51 32.4994V26.5629C51 21.6624 46.9809 17.6842 42.0547 17.6842L42.0547 17.6841ZM25.5059 17.8593C29.7573 17.8593 33.1097 21.1623 33.1097 25.3077V31.0108H17.8988V25.3077C17.8988 21.1623 21.2541 17.8593 25.5055 17.8593H25.5059Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  <span className="mt-4"></span>
                  <span>New Jobs</span>
                </div>
                <img alt="ring" className="h-44" src={Ellipse3} />
              </div>
            </div>
            <ListOfJobs setJobId={setJobId} />
          </>
        ) : (
          <div>{card === "timesheets" && <Timesheet setCard={setCard} />}</div>
        )
      ) : (
        <OngoingJobInformation jobId={jobId} reset={() => setJobId(null)} />
      )}
    </div>
  );
}
